import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  rootStatusCourseContent: {
    height: 188,
    width: "100%",
    // minWidth: "288px",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("xs")]: {
      height: "172px",
      padding: "8px",
    },
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  courseNameContainer: {
    flexGrow: 1,
    marginBottom: 8,
  },
  courseName: {
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    whiteSpace: "normal",
    overflow: "hidden",
  },
  blockedMessageContainer: {
    border: `1px solid ${theme.palette.colors.fillStroke[200]}`,
    borderRadius: "8px",
    display: "flex",
    padding: "8px 24px 8px 16px",
    alignItems: "center",
    gap: "8px",
    alignSelf: "stretch",
  },
  blockedMessageText: {
    color: theme.palette.colors.fillStroke[100],
    // fontSize: "10px",
    // lineHeight: "16px",
  },
}));
